(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/draws-actions.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/draws-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk,
  createAction = _RTK.createAction;
const DrawState = svs.components.sport.tipsenShared.DrawState;
const _svs$components$sport = svs.components.sport.drawsRedux,
  normalizeDraws = _svs$components$sport.normalizeDraws,
  FetchState = _svs$components$sport.FetchState,
  normalizeFunds = _svs$components$sport.normalizeFunds;
const getJackpots = svs.content.shared.getJackpots;
const products = svs.utils.products;
const _svs$components$sport2 = svs.components.sport.drawsRedux.services,
  fetchDrawsPromise = _svs$components$sport2.fetchDrawsPromise,
  fetchOpenedDrawsPromise = _svs$components$sport2.fetchOpenedDrawsPromise,
  fetchNetSalePromise = _svs$components$sport2.fetchNetSalePromise;
const processJackpotData = svs.content.shared.jackpotHelpers.processJackpotData;
const fetchRelatedDraws = svs.components.sport.drawsRedux.fetchRelatedDraws;
const Errors = {
  NoOutdatedDraws: 'NoOutdatedDrawsError'
};
const loadOpenedDraws = createAsyncThunk('loadOpenedDraws', async drawAPIPath => {
  const draws = await fetchOpenedDrawsPromise(drawAPIPath);
  const normalizedDraws = normalizeDraws(draws);
  const Funds = normalizeFunds(draws, undefined);
  return _objectSpread(_objectSpread({}, normalizedDraws), {}, {
    Funds
  });
});
const selectOutdatedDraws = (state, productId, drawNumbers) => drawNumbers.filter(drawNumber => {
  const drawKey = "".concat(productId, "_").concat(drawNumber);
  const draw = state.Draws.entities[drawKey];
  const fetchState = state.Draws.requests[drawKey];
  const lastLoaded = new Date(state.Draws.loaded[drawKey]);
  const isDrawLive = draw && new Date(draw.regCloseTime) < Date.now() && draw.drawStateId > DrawState.Opened && draw.drawStateId < DrawState.WinpayoutStarted;
  const maxDiffSeconds = (isDrawLive ? 1 : 5) * 60;
  let elapsedSeconds;
  if (dateFns.isValid(lastLoaded)) {
    elapsedSeconds = dateFns.differenceInSeconds(new Date(), lastLoaded);
  } else {
    elapsedSeconds = Number.POSITIVE_INFINITY;
  }
  return fetchState !== FetchState.Pending && elapsedSeconds > maxDiffSeconds;
});
const loadDrawsLite = createAsyncThunk('loadDrawsLite', fetchRelatedDraws, {
  condition: (_ref, _ref2) => {
    let relatedProductId = _ref.relatedProductId;
    let getState = _ref2.getState;
    const itsProductId = products.getSpecificDrawName(relatedProductId);
    const cacheKey = [itsProductId, 'lite'].join('_');
    const lastLoaded = new Date(getState().Draws.loaded[cacheKey]);
    let elapsedMinutes;
    if (dateFns.isValid(lastLoaded)) {
      elapsedMinutes = dateFns.differenceInMinutes(new Date(), lastLoaded);
    } else {
      elapsedMinutes = Number.POSITIVE_INFINITY;
    }
    const fetchState = getState().Draws.requests[cacheKey];
    if (fetchState === FetchState.Pending || elapsedMinutes < 5) {
      return false;
    }
  }
});
const loadOpenedDrawsByEngine = createAsyncThunk('loadOpenedDrawsByEngine', async engineDefinition => {
  const _await$Promise$all = await Promise.all([fetchOpenedDrawsPromise(engineDefinition.loadDrawsApiPath), getJackpots(engineDefinition.drawProductIds)]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    draws = _await$Promise$all2[0],
    jackpots = _await$Promise$all2[1];
  const Funds = normalizeFunds(draws, jackpots);
  const normalizedDraws = normalizeDraws(draws);
  return _objectSpread(_objectSpread({}, normalizedDraws), {}, {
    Funds
  });
}, {
  condition: (engineDefinition, _ref3) => {
    let getState = _ref3.getState;
    const lastLoaded = new Date(getState().Draws.loaded[engineDefinition.loadDrawsApiPath]);
    let elapsedMinutes;
    if (dateFns.isValid(lastLoaded)) {
      elapsedMinutes = dateFns.differenceInMinutes(new Date(), lastLoaded);
    } else {
      elapsedMinutes = Number.POSITIVE_INFINITY;
    }
    const fetchState = getState().Draws.requests[engineDefinition.loadDrawsApiPath];
    if (fetchState === FetchState.Pending || elapsedMinutes < 5) {
      return false;
    }
  }
});
const loadDrawByProduct = createAsyncThunk('loadDrawByProduct', async (_ref4, _ref5) => {
  let productId = _ref4.productId,
    outdatedDrawNumbers = _ref4.outdatedDrawNumbers,
    _ref4$shouldFetchJack = _ref4.shouldFetchJackpot,
    shouldFetchJackpot = _ref4$shouldFetchJack === void 0 ? false : _ref4$shouldFetchJack;
  let rejectWithValue = _ref5.rejectWithValue;
  if (!outdatedDrawNumbers.length) {
    return rejectWithValue({
      name: Errors.NoOutdatedDraws
    });
  }
  const _await$fetchDrawsProm = await fetchDrawsPromise(productId, outdatedDrawNumbers, shouldFetchJackpot),
    _await$fetchDrawsProm2 = _slicedToArray(_await$fetchDrawsProm, 2),
    drawsResponses = _await$fetchDrawsProm2[0],
    jackpotResponses = _await$fetchDrawsProm2[1];
  const draws = drawsResponses.draws.map(drawsResponse => drawsResponse.draw);
  const jackpots = jackpotResponses.reduce((jackpots, jackpotResponse) => jackpots.concat(processJackpotData([jackpotResponse.jackpot])), []);
  const Funds = normalizeFunds(draws, jackpots);
  const normalizedDraws = normalizeDraws(draws);
  const rejectedDraws = drawsResponses.rejectedDraws.reduce((rejectedDraws, drawsResponse, index) => {
    if (drawsResponse.error) {
      rejectedDraws.push("".concat(productId, "_").concat(outdatedDrawNumbers[index]));
    }
    return rejectedDraws;
  }, []);
  return {
    Funds,
    draws: normalizedDraws,
    rejectedDraws
  };
}, {
  getPendingMeta: (_ref6, _ref7) => {
    let arg = _ref6.arg;
    let getState = _ref7.getState;
    const productId = arg.productId,
      drawNumber = arg.drawNumber;
    const drawNumbers = [].concat(drawNumber);
    const outdatedDrawNumbers = selectOutdatedDraws(getState(), productId, drawNumbers);
    const retainedDrawNumbers = drawNumbers.filter(drawNumber => !outdatedDrawNumbers.includes(drawNumber));
    Object.assign(arg, {
      outdatedDrawNumbers,
      retainedDrawNumbers
    });
  },
  condition: (_ref8, _ref9) => {
    let productId = _ref8.productId,
      drawNumber = _ref8.drawNumber;
    let getState = _ref9.getState;
    if (!Number(productId)) {
      return false;
    }
    const drawNumbers = [].concat(drawNumber);
    if (!drawNumbers.length || !drawNumbers.every(Number)) {
      return false;
    }
    const fetchState = getState().Draws.requests["".concat(productId, "_").concat(drawNumber)];
    if (fetchState === FetchState.Pending) {
      return false;
    }
  }
});
const updateDraw = createAction('tipsen/updateDraw', function (_ref0) {
  let drawResponse = _ref0.drawResponse;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    payload: _objectSpread(_objectSpread({}, normalizeDraws([drawResponse])), {}, {
      Funds: normalizeFunds([drawResponse], undefined)
    }),
    meta: _objectSpread({}, options)
  };
});
const loadNetSaleForDraws = createAsyncThunk('loadNetSaleForDraws', async _ref1 => {
  let productId = _ref1.productId;
  const netSaleResponse = await fetchNetSalePromise({
    productId
  });
  return {
    Draws: netSaleResponse
  };
});
setGlobal('svs.components.sport.drawsRedux.constants.Errors', Errors);
setGlobal('svs.components.sport.drawsRedux.actions', {
  loadOpenedDraws,
  loadOpenedDrawsByEngine,
  loadDrawByProduct,
  updateDraw,
  loadDrawsLite,
  loadNetSaleForDraws
});

 })(window);